// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.renewal-modal-container .box {
  max-width: 600px;
}
.renewal-modal-container .box form .group-info {
  margin-bottom: 1rem;
  padding-top: 1rem;
  padding-bottom: 0;
  border-top: 1px solid var(--ods-color-gray-30);
}
.renewal-modal-container .box form .group-info h4 {
  margin-top: 0;
  margin-bottom: 0.75rem;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.4;
  color: var(--ods-color-gray-100);
}
.renewal-modal-container .box form p {
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0.5rem 0;
  color: var(--ods-color-gray-90);
}
.renewal-modal-container .box form p strong {
  font-weight: 600;
  color: var(--ods-color-gray-100);
}
.renewal-modal-container .box form .decline-request-info {
  background-color: var(--ods-color-gray-10);
  padding: 1rem;
  margin: 1.5rem 0;
  border-radius: 4px;
  border-left: 3px solid var(--ods-color-purple-50);
}
.renewal-modal-container .box form .decline-request-info p {
  margin: 0.5rem 0;
}
.renewal-modal-container .box form .decline-request-info p:first-child {
  margin-top: 0;
}
.renewal-modal-container .box form .decline-request-info p:last-child {
  margin-bottom: 0;
}
.renewal-modal-container .box form .statement-text {
  padding: 1.5rem 0;
  line-height: 1.6;
}
.renewal-modal-container .box form .form-field {
  margin-bottom: 1.5rem;
}
.renewal-modal-container .box form .form-field .field-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.625rem;
  color: var(--ods-color-gray-100);
  line-height: 1.4;
}
.renewal-modal-container .box form orchid-select[className=decline-reason],
.renewal-modal-container .box form ods-select[className=decline-reason] {
  width: 100%;
  max-width: 550px;
}
.renewal-modal-container .box form textarea {
  display: block;
  width: 100%;
  max-width: 550px;
  padding: 0.75rem;
  border: 1px solid var(--ods-color-gray-50);
  border-radius: 4px;
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.5;
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.renewal-modal-container .box form textarea:hover {
  border-color: var(--ods-color-gray-70);
}
.renewal-modal-container .box form textarea:focus {
  outline: none;
  border-color: var(--ods-color-purple-50);
  box-shadow: 0 0 0 3px rgba(138, 43, 226, 0.1);
}
.renewal-modal-container .box form textarea::placeholder {
  color: var(--ods-color-gray-60);
}
.renewal-modal-container .box form .description-text {
  margin-top: 1.5rem;
  padding: 1rem;
  font-size: 0.875rem;
  line-height: 1.6;
  background-color: var(--ods-color-gray-10);
  border-radius: 4px;
  color: var(--ods-color-gray-90);
}
.renewal-modal-container .box form .description-text b,
.renewal-modal-container .box form .description-text strong {
  color: var(--ods-color-gray-100);
}
.renewal-modal-container .box form .decline-renewal-buttons {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  align-items: center;
  padding-top: 1rem;
  margin-top: 1.5rem;
  border-top: 1px solid var(--ods-color-gray-20);
}
.renewal-modal-container .box form .decline-renewal-buttons ods-button {
  min-width: 120px;
}

::ng-deep .renewal-modal-container .pop-up-box__header {
  border-bottom: 1px solid var(--ods-color-gray-30);
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
}
::ng-deep .renewal-modal-container .pop-up-box__header-title {
  color: var(--ods-color-purple-50) !important;
  margin-bottom: 0;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.3;
}
::ng-deep .renewal-modal-container .pop-up-box__content {
  padding: 0 1.5rem 1.5rem;
}
::ng-deep orchid-select[className=decline-reason] .orchid-select__selected-option,
::ng-deep orchid-select[className=decline-reason] .orchid-select__select-option-list,
::ng-deep orchid-select[className=decline-reason] .ods-select__selected-option,
::ng-deep orchid-select[className=decline-reason] .ods-select__select-option-list,
::ng-deep ods-select[className=decline-reason] .orchid-select__selected-option,
::ng-deep ods-select[className=decline-reason] .orchid-select__select-option-list,
::ng-deep ods-select[className=decline-reason] .ods-select__selected-option,
::ng-deep ods-select[className=decline-reason] .ods-select__select-option-list {
  width: 100%;
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/ep-quote-declination/ep-quote-declination.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAIM;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,8CAAA;AAFR;AAIQ;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAFV;AAOM;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;AALR;AAOQ;EACE,gBAAA;EACA,gCAAA;AALV;AAUM;EACE,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;AARR;AAUQ;EACE,gBAAA;AARV;AAUU;EACE,aAAA;AARZ;AAWU;EACE,gBAAA;AATZ;AAeM;EACE,iBAAA;EACA,gBAAA;AAbR;AAiBM;EACE,qBAAA;AAfR;AAiBQ;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gCAAA;EACA,gBAAA;AAfV;AAoBM;;EAEE,WAAA;EACA,gBAAA;AAlBR;AAsBM;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wEAAA;AApBR;AAsBQ;EACE,sCAAA;AApBV;AAuBQ;EACE,aAAA;EACA,wCAAA;EACA,6CAAA;AArBV;AAwBQ;EACE,+BAAA;AAtBV;AA2BM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,+BAAA;AAzBR;AA2BQ;;EAEE,gCAAA;AAzBV;AA8BM;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;AA5BR;AA8BQ;EACE,gBAAA;AA5BV;;AAsCI;EACE,iDAAA;EACA,oBAAA;EACA,qBAAA;AAnCN;AAsCI;EACE,4CAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AApCN;AAwCI;EACE,wBAAA;AAtCN;AA6CI;;;;;;;;EAIE,WAAA;EACA,mBAAA;AAvCN","sourcesContent":[".renewal-modal-container {\n  .box {\n    max-width: 600px;\n\n    form {\n      // Header section with group information\n      .group-info {\n        margin-bottom: 1rem;\n        padding-top: 1rem;\n        padding-bottom: 0;\n        border-top: 1px solid var(--ods-color-gray-30);\n\n        h4 {\n          margin-top: 0;\n          margin-bottom: 0.75rem;\n          font-weight: 600;\n          font-size: 1rem;\n          line-height: 1.4;\n          color: var(--ods-color-gray-100);\n        }\n      }\n\n      // Metadata text (Agent, General Agency, etc.)\n      p {\n        font-size: 0.875rem;\n        line-height: 1.5;\n        margin: 0.5rem 0;\n        color: var(--ods-color-gray-90);\n\n        strong {\n          font-weight: 600;\n          color: var(--ods-color-gray-100);\n        }\n      }\n\n      // Producer request info section\n      .decline-request-info {\n        background-color: var(--ods-color-gray-10);\n        padding: 1rem;\n        margin: 1.5rem 0;\n        border-radius: 4px;\n        border-left: 3px solid var(--ods-color-purple-50);\n\n        p {\n          margin: 0.5rem 0;\n\n          &:first-child {\n            margin-top: 0;\n          }\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n\n      // Statement text for Accept Enrollment\n      .statement-text {\n        padding: 1.5rem 0;\n        line-height: 1.6;\n      }\n\n      // Form fields section\n      .form-field {\n        margin-bottom: 1.5rem;\n\n        .field-label {\n          display: block;\n          font-size: 0.875rem;\n          font-weight: 600;\n          margin-bottom: 0.625rem;\n          color: var(--ods-color-gray-100);\n          line-height: 1.4;\n        }\n      }\n\n      // Select dropdown styling\n      orchid-select[className=\"decline-reason\"],\n      ods-select[className=\"decline-reason\"] {\n        width: 100%;\n        max-width: 550px;\n      }\n\n      // Textarea styling\n      textarea {\n        display: block;\n        width: 100%;\n        max-width: 550px;\n        padding: 0.75rem;\n        border: 1px solid var(--ods-color-gray-50);\n        border-radius: 4px;\n        font-family: inherit;\n        font-size: 0.875rem;\n        line-height: 1.5;\n        resize: vertical;\n        min-height: 80px;\n        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n        &:hover {\n          border-color: var(--ods-color-gray-70);\n        }\n\n        &:focus {\n          outline: none;\n          border-color: var(--ods-color-purple-50);\n          box-shadow: 0 0 0 3px rgba(138, 43, 226, 0.1);\n        }\n\n        &::placeholder {\n          color: var(--ods-color-gray-60);\n        }\n      }\n\n      // Description text at bottom\n      .description-text {\n        margin-top: 1.5rem;\n        padding: 1rem;\n        font-size: 0.875rem;\n        line-height: 1.6;\n        background-color: var(--ods-color-gray-10);\n        border-radius: 4px;\n        color: var(--ods-color-gray-90);\n\n        b,\n        strong {\n          color: var(--ods-color-gray-100);\n        }\n      }\n\n      // Footer button section\n      .decline-renewal-buttons {\n        display: flex;\n        gap: 0.75rem;\n        justify-content: flex-end;\n        align-items: center;\n        padding-top: 1rem;\n        margin-top: 1.5rem;\n        border-top: 1px solid var(--ods-color-gray-20);\n\n        ods-button {\n          min-width: 120px;\n        }\n      }\n    }\n  }\n}\n\n::ng-deep {\n  .renewal-modal-container {\n    // Modal header styling\n    .pop-up-box__header {\n      border-bottom: 1px solid var(--ods-color-gray-30);\n      padding-bottom: 1rem;\n      margin-bottom: 1.5rem;\n    }\n\n    .pop-up-box__header-title {\n      color: var(--ods-color-purple-50) !important;\n      margin-bottom: 0;\n      font-size: 1.25rem;\n      font-weight: 600;\n      line-height: 1.3;\n    }\n\n    // Content padding\n    .pop-up-box__content {\n      padding: 0 1.5rem 1.5rem;\n    }\n  }\n\n  // Select dropdown internal styling\n  orchid-select[className=\"decline-reason\"],\n  ods-select[className=\"decline-reason\"] {\n    .orchid-select__selected-option,\n    .orchid-select__select-option-list,\n    .ods-select__selected-option,\n    .ods-select__select-option-list {\n      width: 100%;\n      font-size: 0.875rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
